// Set Heights, [alberto] add another condition to cover resized desktop browser
if(!isMobile() && !isTablet() && window.innerWidth > 768 && $.fn.equalHeightGrid) {
    for(var i = 0; i < 12; i++){
        $('.col-height-' + i).equalHeightGrid(i);
    }
    for(var i = 0; i < 12; i++){
        $('.col-height-responsive-' + i).responsiveEqualHeightGrid(i);
    }
}

function isMobile() {
    return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function isTablet() {
    return /ipad/i.test(navigator.userAgent);
}

$(document).ready(function() {
    $('body :not(script)').contents().filter(function() {
        return this.nodeType === 3;
    }).replaceWith(function() {
        return this.nodeValue.replace('™', '<span class="trademark-font">™</span>');
    });

    var $homeDownloadButton = $('.general-download-button');

    $homeDownloadButton.click(function(e) {
        e.preventDefault();

        var $that = $(this),
            tabName = 'start';

        if(isMobile()) {
            tabName = 'mobile-download-app-select';
        }

        $.fn.toppsRedeem().open(tabName);

        return false;
    });

    var $submitMobileDownloadAppSelect = $('#submit-mobile-download-app-select');

    $submitMobileDownloadAppSelect.click(function(e) {
        e.preventDefault();

        var $select = $('#mobile_download_app');
        var link = $select.val();

        if(link) {
            window.open(link);
        }

        return false;
    });
});